export const GOOGLE_MAPS_QUERY_TEMPLATE = 'https://www.google.com/maps?q='

export const SOCIAL_LINKS = {
  FACEBOOK: 'https://www.facebook.com/startupcraft.io',
  TWITTER: 'https://twitter.com/startupcraftio',
  MEDIUM: 'https://medium.com/startupcraft',
  LINKED_IN: 'https://www.linkedin.com/company/startupcraft',
  UPWORK: 'https://www.upwork.com/o/companies/~017a75f81b71aeddc3/',
  CLUTCH: 'https://clutch.co/profile/startupcraft',
}

enum TopClutchLinkId {
  ClutchBlockchain = 'clutchBlockchain',
  ClutchEthereum = 'clutchEthereum',
  ClutchInitialCoin = 'clutchInitialCoin',
  ClutchSmartContract = 'clutchSmart Contract',
}

export const TOP_CLUTCH_LINK = {
  [TopClutchLinkId.ClutchBlockchain]: {
    id: TopClutchLinkId.ClutchBlockchain,
    src: 'https://shareables.clutch.co/share/badges/139131/83698?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Blockchain Company 2023 Award',
  },
  [TopClutchLinkId.ClutchEthereum]: {
    id: TopClutchLinkId.ClutchEthereum,
    src: 'https://shareables.clutch.co/share/badges/139131/83638?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Ethereum Company 2023 Award',
  },
  [TopClutchLinkId.ClutchInitialCoin]: {
    id: TopClutchLinkId.ClutchInitialCoin,
    src: 'https://shareables.clutch.co/share/badges/139131/83616?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Initial Coin Offering Consulting Company 2023 Award',
  },
  [TopClutchLinkId.ClutchSmartContract]: {
    id: TopClutchLinkId.ClutchSmartContract,
    src: 'https://shareables.clutch.co/share/badges/139131/83902?utm_source=clutch_award_badge&utm_medium=image_embed',
    title: 'Top Clutch Smart Contract Development Company 2023 Award',
  },
}

export const CLUTCH_REVIEW_DATA = {
  dataUrl: 'https://widget.clutch.co',
  scriptSrc: 'https://widget.clutch.co/static/js/widget.js',
  companyId: '139131',
  link: 'https://clutch.co/profile/startupcraft?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=num_reviews&utm_term=localhost#reviews',
}

export const DATO_CMS_ENDPOINTS = {
  preview: `https://graphql.datocms.com/preview`,
  production: `https://graphql.datocms.com/`,
}
